interface DeviceHints {
  readonly userAgent: string;
  readonly maxTouchPoints?: number;
  readonly userAgentData?: { readonly platform?: string };
}

export function detectStorePlatform(device: DeviceHints): "ios" | "android" | null {
  const ua = device.userAgent;
  // Windows Phone UAs can include both Android and iPhone compatibility tokens.
  if (/Windows Phone|IEMobile/i.test(ua)) return null;
  if (device.userAgentData?.platform === "Android" || /Android/i.test(ua)) {
    return "android";
  }
  if (/iPhone|iPad|iPod/i.test(ua)) return "ios";
  // iPadOS desktop browsing reports a Mac UA. Treat this only as a download
  // hint, not an identity check; explicit store badges always remain available.
  if (/Macintosh/i.test(ua) && (device.maxTouchPoints ?? 0) > 1) return "ios";
  return null;
}

export function enhanceDownloadLinks(root: Document, device: DeviceHints): void {
  const platform = detectStorePlatform(device);
  if (!platform) return;
  // Read the official badge's destination so the CTA cannot drift to a different
  // listing. Keep the HTML anchor fallback when JS or detection is unavailable.
  const destination = root.querySelector<HTMLAnchorElement>(`[data-store="${platform}"]`)?.href;
  if (!destination) return;
  for (const link of root.querySelectorAll<HTMLAnchorElement>("[data-smart-download]")) {
    // Native links preserve keyboard, open-in-new-tab and browser back behavior;
    // no click interception, popup or automatic page-load redirect is needed.
    link.href = destination;
  }
}
